//
//
//
//
//
//
//
//
//

import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons'
import EscrowBalance from '@/components/escrow/EscrowBalance'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'
import { escrowStatuses } from 'ct-constants'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDetailsEscrow',
  components: {
    TaskDetailsItem,
    EscrowBalance
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    visible () {
      return this.task.escrowStatus === escrowStatuses.ESCROW_SET
    },
    moneyIcon () {
      return faHandHoldingUsd
    }
  }
}
